export default String.raw`
{% if settings.blockCompanyDataEdition == 'no' -%}
    {% assign canEditCustomerDetails = true -%}
{% elseif settings.blockCompanyDataEditionFor == 'withLimits' and customer.CreditLimit == null -%}
    {% assign canEditCustomerDetails = true -%}
{% else -%}
    {% assign canEditCustomerDetails = false -%}
{% endif -%}

<div class="customer-info">
    <div class="customer-info__header">
        <h4>
            {% assign nameSize = customer.Address.Name | Size -%}
            {{ customer.Address.Name }}{% if nameSize < 40 -%}&nbsp;{% endif -%}{{ customer.Address.Name2 }}
        </h4>
        {% if customer.CustomerDetailsEditable and canEditCustomerDetails -%}
        <button class="pure-button replace-company-edit-template-js set-focus-trap-js container-reload-js opening-modal-mobile-js" data-template="partials/customer-profile/customer-details/cst-data-form.html" data-edit-data-from-gus="{{settings.editDataFromGUS}}" data-edit-data-from-vies="{{settings.editDataFromVIES}}">
            <span>{{ translations.Edit }}</span>
        </button>
        {% endif -%}
    </div>
    <div class="customer-info__container">
        <div class="customer-info__content">
            <div class="title">{{ translations.Address }}</div>
            <span>{{ customer.Address.Street}} {{ customer.Address.StreetNo}}{% if customer.Address.UnitNo != '' -%}/{{ customer.Address.UnitNo}}{% endif -%}</span>
            <span>{{ customer.Address.ZipCode }} {{ customer.Address.City }}</span>
            <span>{{ config.Countries[customer.Address.Country].Name }}</span>
        </div>
        <div class="customer-info__content">
            <div class="title">{{ translations.Email }}</div>
            <span>
                {{customer.Address.Email}}
            </span>
        </div>
        {% if customer.Address.PhoneNo != '' -%}
        <div class="customer-info__content">
            <div class="title">{{ translations.Phone }}</div>
            <span>{{ customer.Address.PhoneNo }}</span>
        </div>
        {% endif -%}
        <div class="customer-info__content">
            {% if customer.Company == true -%}<div class="title">{{ translations.TIN }}</div> {% if config.ENTERPRISE and customer.VATEU != '' -%}<span>{{ customer.VATEU }} {% endif -%}{{ customer.TIN }}</span>{% endif -%}
        </div>
    </div>
</div>
`